module.exports = __webpack_public_path__ + "static/media/game_cover_flamingcore.02618a43.png";